import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

// Get a reference to the root element
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// Register the service worker for PWA support
const { serviceWorker } = serviceWorkerRegistration.register();

// Render the app
root.render(
  <React.StrictMode>
    <App serviceWorker={serviceWorker} />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
